<template>
  <div>
    <section>
      <v-parallax src="assets/beach-1853939_1920.jpg" height="500">
      </v-parallax>
    </section>

    <section>
      <v-layout column wrap class="my-5" align-center>
        <v-flex xs12 sm4 class="my-3">
          <div class="text-xs-center">
            <h2 class="primary--text display-1">
              The best way to start driving
            </h2>
            <span class="subheading accent--text"
              >Friendly, Relaxed Lessons</span
            >
          </div>
        </v-flex>
        <v-flex xs12>
          <v-container grid-list-xl>
            <v-layout row wrap align-center>
              <v-flex xs12 md4>
                <v-card class="elevation-0 transparent">
                  <v-card-text class="text-xs-center">
                    <v-icon x-large class="orange--text text--lighten-2"
                      >star</v-icon
                    >
                  </v-card-text>
                  <v-card-title primary-title class="layout justify-center">
                    <div class="headline text-xs-center accent--text">
                      Our Record
                    </div>
                  </v-card-title>
                  <v-card-text>
                    At Rownhams School of Motoring we actively support the DSA
                    ethic of Safe driving for life. We consistently achieve high
                    pass rates in the fewest possible lessons. Not only do we
                    get you driving in the shortest possible time, we can save
                    you the money that you would spend on unnecessary lessons.
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md4>
                <v-card class="elevation-0 transparent">
                  <v-card-text class="text-xs-center">
                    <v-icon x-large class="orange--text text--lighten-2"
                      >thumb_up</v-icon
                    >
                  </v-card-text>
                  <v-card-title primary-title class="layout justify-center">
                    <div class="headline text-xs-center accent--text">
                      Our Promise
                    </div>
                  </v-card-title>
                  <v-card-text>
                    You can relax in the knowledge that you will be taught by a
                    fully qualified and experienced Instructor (Grade A ADI)
                    with a first class pass rate. You will also be reassured to
                    know that you will learn in a brand new BMW Mini fitted with
                    the latest dual controls. We believe this is the best car
                    currently available for learning to drive.
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md4>
                <v-card class="elevation-0 transparent">
                  <v-card-text class="text-xs-center">
                    <v-icon x-large class="orange--text text--lighten-2"
                      >credit_card</v-icon
                    >
                  </v-card-text>
                  <v-card-title primary-title class="layout justify-center">
                    <div class="headline text-xs-center accent--text">
                      Our Rates
                    </div>
                  </v-card-title>
                  <v-card-text>
                    We offer very competitive rates. You can book by the hour or
                    save money by booking a block of 10 hours at a considerable
                    discount. We also offer a discount for Pass Plus lessons if
                    you passed with us. Please get in touch and we can discuss
                    what arrangement suits you best.
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </section>

    <section>
      <v-parallax src="assets/legs-434918_1920.jpg" height="380">
        <v-layout column align-center justify-center>
          <div class="display-2 primary--text mb-3 text-xs-center">
            Learning to drive has never been easier
          </div>
          <em class="primary--text display-1"
            >Call today and get started right away</em
          >
        </v-layout>
      </v-parallax>
    </section>

    <section>
      <v-container grid-list-xl>
        <v-layout row wrap justify-center class="my-5">
          <v-flex xs12 sm4>
            <v-card class="elevation-0 transparent">
              <v-card-title primary-title class="layout justify-center">
                <div class="headline primary--text">Company info</div>
              </v-card-title>
              <v-card-text>
                At Rownhams School of Motoring we have been helping people to
                drive for the past 15 years and we would be delighted to help
                you too. We cover Rownhams and the surrounding area so please
                get in touch to get started.
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm4 offset-sm1>
            <v-card class="elevation-0 transparent">
              <v-card-title primary-title class="layout justify-center">
                <div class="headline primary--text">Contact us</div>
              </v-card-title>
              <v-card-text>
                You can call or email me anytime to discuss what we can do for
                you.
              </v-card-text>
              <v-list class="transparent">
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="orange--text text--lighten-2">phone</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title
                      ><a href="tel">0782 558 0910</a>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="orange--text text--lighten-2">place</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Rownhams, Hants.</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="orange--text text--lighten-2">email</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title
                      ><a href="mailto:gtk124@hotmail.com"
                        >gtk124@hotmail.com</a
                      >
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <v-footer class="blue darken-2">
      <v-layout row wrap align-center>
        <v-flex xs12>
          <div class="white--text ml-3">Rownhams School Of Motoring</div>
        </v-flex>
      </v-layout>
    </v-footer>
  </div>
</template>

<script>
export default {
  name: "Home",
  props: {
    msg: String
  },
  methods: {
    getImgUrl(img) {
      require("../assets/" + img);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
a {
  text-decoration: none;
}
</style>
